<template>
  <div>
    <a class="articleTitle" :href="article.link" target="_blank"> {{ articleDate }} {{ article.title }} </a>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  name: 'NewsArticle',
  props: ['article'],
  computed: {
    articleDate() {
      return moment(this.article.article_date).format('YYYY MMMM DD')
    }
  }
}

</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration:underline;
}
</style>
